{
  "base": "vs",
  "inherit": true,
  "rules": [
    {
      "background": "EEEEEEEB",
      "token": ""
    },
    {
      "foreground": "009933",
      "token": "string"
    },
    {
      "foreground": "0066ff",
      "token": "constant.numeric"
    },
    {
      "foreground": "ff0080",
      "token": "string.regexp"
    },
    {
      "foreground": "0000ff",
      "token": "keyword"
    },
    {
      "foreground": "9700cc",
      "token": "constant.language"
    },
    {
      "foreground": "990000",
      "token": "support.class.exception"
    },
    {
      "foreground": "ff8000",
      "token": "entity.name.function"
    },
    {
      "fontStyle": "bold underline",
      "token": "entity.name.type"
    },
    {
      "fontStyle": "italic",
      "token": "variable.parameter"
    },
    {
      "foreground": "0066ff",
      "fontStyle": "italic",
      "token": "comment"
    },
    {
      "foreground": "ff0000",
      "background": "e71a114d",
      "token": "invalid"
    },
    {
      "background": "e71a1100",
      "token": "invalid.deprecated.trailing-whitespace"
    },
    {
      "foreground": "000000",
      "background": "fafafafc",
      "token": "text source"
    },
    {
      "foreground": "0033cc",
      "token": "meta.tag"
    },
    {
      "foreground": "0033cc",
      "token": "declaration.tag"
    },
    {
      "foreground": "6782d3",
      "token": "constant"
    },
    {
      "foreground": "6782d3",
      "token": "support.constant"
    },
    {
      "foreground": "3333ff",
      "fontStyle": "bold",
      "token": "support"
    },
    {
      "fontStyle": "bold",
      "token": "storage"
    },
    {
      "fontStyle": "bold underline",
      "token": "entity.name.section"
    },
    {
      "foreground": "000000",
      "fontStyle": "bold",
      "token": "entity.name.function.frame"
    },
    {
      "foreground": "333333",
      "token": "meta.tag.preprocessor.xml"
    },
    {
      "foreground": "3366cc",
      "fontStyle": "italic",
      "token": "entity.other.attribute-name"
    },
    {
      "fontStyle": "bold",
      "token": "entity.name.tag"
    }
  ],
  "colors": {
    "editor.foreground": "#000000",
    "editor.background": "#FFFFFFFF",
    "editor.selectionBackground": "#BAD6FD",
    "editor.lineHighlightBackground": "#0000001A",
    "editorCursor.foreground": "#000000",
    "editorWhitespace.foreground": "#B3B3B3F4"
  }
}